module.exports = __webpack_public_path__ + "img/default_silver.7203ecd7.png";